import React, { useEffect, useState } from 'react';
import Header from '../AssetHealthApp/Header';
import { getSA30URL } from '../../utils/helper';

const EmbedComponent = () => {
  const [embedUrl, setEmbedUrl] = useState('');

  const iframStyle = {
    position: 'absolute',
    top: 50,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none',
  };

  useEffect(() => {
    const url = getSA30URL();
    if (url) {
      setEmbedUrl(url);
    } else {
      console.error('Embed URL is not defined in the environment variables.');
    }
  }, []);

  return (
    <React.Fragment>
      <Header BrandText={'Reports'}></Header>
      <div>
        {embedUrl ? (
          <iframe
            title="Embedded Content"
            width="100%"
            src={embedUrl}
            style={iframStyle}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        ) : (
          <p>Loading embed...</p>
        )}
      </div>
    </React.Fragment>
  );
};

export default EmbedComponent;
